import "animate.css";
import { useEffect, useState } from "react";
import GetApiCall from "../../../helper/GetApi";
import Footer from "../../Masala-of-india/Footer/Footer";
import CommonHomeAbout from "../About/About";
import CommonHomeBanner from "../Banner/Banner";
import Catering from "../Catering/Catering";
import CommonHomeDeliveryPartners from "../DeliveryPartners/DeliveryPartners";
import Holiday from "../Holiday/Holiday";
import CommonHomeImageGallery from "../ImageGallery/ImageGallery";
import CommonHomeTestimonial from "../LunchBuffet/LunchBuffet";
import CommonHomeNavbar from "../Navbar/CommonHomeNavbar";
import OfferPopup from "../OfferPopup/OfferPopup";
import Testimonial from "../Testimonial/Testimonial";
import "./CommonHome.css";
import { Helmet } from "react-helmet";

const CommonHome = () => {
  const [offerModalOpen, setOfferModalOpen] = useState(true);
  const [offerBanner, setOfferBanner] = useState("");

  // useEffect(() => {
  //   GetApiCall.getRequest("getBannerDetails").then((results) =>
  //     results?.json().then((obj1) => {
  //       if (results.status == 200 || results.status == 201) {
  //         if (
  //           obj1.message.filter((data) => data.fld_banner_location == "Offer")
  //             .length != 0
  //         ) {
  //           setOfferBanner(
  //             obj1.message.filter((data) => data.fld_banner_location == "Offer")
  //           );
  //           setOfferModalOpen(true);
  //         }
  //       }
  //     })
  //   );
  // }, []);

  function handleCancel() {
    setOfferModalOpen((prevState) => !prevState);
  }

  return (
    <>
      <div className="masla-of-india-home">
        <Helmet>
          {/* meta tags */}
          <title>
            Best Indian Restaurant in Seattle, WA | Masala of India Cuisine
          </title>
          <meta
            name="description"
            content="Masala of India Cuisine is the Authentic Indian restaurant in Northgate, Seattle, WA. Serving Indian food. We offer Dine-in, Lunch Buffet, To-Go, delivery, and Catering Services. "
          />
          <meta
            name="keywords"
            content="Masala of India Cuisine, Best Indian Restaurant in Northgate, Best Indian Restaurant in Seattle, Best Indian Restaurant in Washington - WA, Best Indian Food, Authentic Indian Food, Indian Lunch Buffet, Lunch Buffet, Tandoori Food, North Indian food in Seattle, Halal Food in Seattle, Halal Food in Northgate, North Indian Food, Indian Food Catering, Catering Services in Seattle, Best Catering Services in Seattle, Indian Restaurants near me, Lunch Buffet Near me, Best Indian Restaurant Near me, Sanjay Sharma, Chef Sanjay Sharma, Indian Ala carte Food, To-go Indian Food, Indian Food Delivery, Order Indian Food Online,
            diner, takeaway, indian takeaway, caterer, lunch restaurant, buffet restaurant, family restaurant, free dining restaurant, north indian restaurant, To-Go & Food Delivery, Online Ordering, Table reservations, Baby Showers, Bridal Showers, Rehearsal Dinner, Retirement, Greenwood, Seattle, WA, USA, Northgate, Seattle, WA, USA, Green Lake, Seattle, WA, USA, Maple Leaf, Seattle, WA, USA, Haller Lake, Seattle, WA, USA, Licton Springs, Seattle, WA, USA, Wedgwood, Seattle, WA 98115, USA, Pinehurst, Seattle, WA 98125, USA, Roosevelt, Seattle, WA 98115, USA, Victory Heights, Seattle, WA, USA, Bitter Lake, Seattle, WA 98133, USA, Morningside, Seattle, WA 98115, USA"
          />

          {/* OG tags */}
          <meta
            property="og:title"
            content="Best Indian Restaurant in Seattle, WA | Masala of India Cuisine"
            data-react-helmet="true"
          />
          <meta
            property="og:description"
            content="Masala of India Cuisine is the Authentic Indian restaurant in Northgate, Seattle, WA. Serving Indian food. We offer Dine-in, Lunch Buffet, To-Go, delivery, and Catering Services. "
            data-react-helmet="true"
          />
          <meta property="og:type" content="website" />
          <meta property="og:url" content="https://www.masalaofindia.com/" />
          <meta
            property="og:image"
            content="https://www.masalaofindia.com/static/media/masala-of-india.c5a7d2004e43f4db1721.png"
            data-react-helmet="true"
          />
          <meta property="og:site_name" content="masala of india cuisine" />

          {/* Twitter tags */}
          <meta
            name="twitter:title"
            content="Best Indian Restaurant in Seattle, WA | Masala of India Cuisine"
          />
          <meta
            name="twitter:description"
            content="Masala of India Cuisine is the Authentic Indian restaurant in Northgate, Seattle, WA. Serving Indian food. We offer Dine-in, Lunch Buffet, To-Go, delivery, and Catering Services. "
          />
          <meta
            name="twitter:image"
            content="https://www.masalaofindia.com/static/media/masala-of-india.c5a7d2004e43f4db1721.png"
          />
          <meta name="twitter:site" content="masala of india cuisine" />
          <link rel="canonical" href="https://www.masalaofindia.com/"></link>
        </Helmet>
        <CommonHomeNavbar />
        <CommonHomeBanner />
        <CommonHomeAbout />
        <CommonHomeImageGallery />
        <Holiday />
        <Catering />
        <CommonHomeTestimonial />
        <Testimonial />
        <CommonHomeDeliveryPartners />
        {/* <CommonHomeLocation /> */}
        {/* <OfferPopup /> */}
        {/* {offerModalOpen && (
          <OfferPopup onCancel={handleCancel} offerBannerImage={offerBanner} />
        )} */}
        <Footer />
      </div>
    </>
  );
};

export default CommonHome;
